import { Fragment as t, isVNode as u, Comment as f, Text as s } from "vue";
const i = (e) => e.map((r) => r.type === t ? typeof r.children != "string" && r.children !== null ? i(r.children) : [r.children] : r).flat(), n = (e) => e.every((r) => u(r) ? r.type === f ? !0 : r.type === s || r.type === t ? r.children ? typeof r.children == "string" ? r.children.trim() === "" : Array.isArray(r.children) ? n(r.children) : !1 : !0 : !1 : !1), y = (e) => n([e]);
export {
  y as isVNodeEmpty,
  i as skipFragment
};
